// extracted by mini-css-extract-plugin
module.exports = {"circleCanvas":"Shape_circleCanvas__3bFlQ","circle":"Shape_circle__3OfEm"};